import React, { useState, useEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import axios from 'axios';
import { logout } from '../auth';
import logo from '../assets/proload_220.png';
import { API_BASE_URL, ENV_NAME, GIT_SHA } from '../config';

const Layout = () => {
  const location = useLocation();
  const [version, setVersion] = useState('');

  const linkStyle = (path) => ({
    display: 'block',
    padding: '10px 15px',
    margin: '10px 0',
    backgroundColor: location.pathname === path ? '#000' : '#fff',
    color: location.pathname === path ? '#fff' : '#000',
    textDecoration: 'none',
    borderRadius: '5px',
    textAlign: 'center',
    border: '1px solid #ccc',
    fontWeight: 'bold',
  });

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/version`, { responseType: 'text' });
        setVersion((res.data || '').toString().trim());
      } catch (err) {
        console.error('Failed to fetch version:', err);
      }
    };
    fetchVersion();
  }, []);

  const isTest = ENV_NAME === 'TEST';

  return (
    <div>
      {/* Fixed Sidebar */}
      <nav
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '220px',
          height: '100vh',
          background: '#f0f0f0',
          display: 'flex',
          flexDirection: 'column',
          boxSizing: 'border-box',
          padding: '1rem 0',
          borderRight: '1px solid #ddd'
        }}
      >
        {/* top brand */}
        <div
          style={{
            backgroundColor: '#f0f0f0',
            padding: '1rem',
            textAlign: 'center',
          }}
        >
          <img
            src={logo}
            alt="Proload Logo"
            style={{ width: '60px', height: '60px' }}
          />
          <div style={{ fontSize: '1rem', fontWeight: 'bold', marginTop: '0.25rem' }}>
            Proload
          </div>
        </div>

        {/* nav links */}
        <div style={{ padding: '1rem', flexGrow: 1 }}>
          <Link to="/usage-summary" style={linkStyle('/usage-summary')}>Usage Summary</Link>
          <Link to="/detailed-usage" style={linkStyle('/detailed-usage')}>Detailed Usage</Link>
          <Link to="/installer-tracker" style={linkStyle('/installer-tracker')}>Installer Tracker</Link>
          <Link to="/license-management" style={linkStyle('/license-management')}>License Management</Link>
          <Link to="/error-reports" style={linkStyle('/error-reports')}>Error Reports</Link>
          <Link to="/website-downloads" style={linkStyle('/website-downloads')}>Email Tracker</Link>
          <a
          href="https://api.proloadsolutions.com/swagger/index.html"
          target="_blank"
          rel="noreferrer"
          style={linkStyle('/swagger')}
          >
          Swagger/API
          </a>
        </div>

        {/* Logout */}
        <div style={{ padding: '1rem', borderTop: '1px solid #ddd', textAlign: 'center' }}>
          <button
            onClick={() => logout()}
            style={{
              background: '#c00',
              color: 'white',
              border: 'none',
              padding: '0.5rem 1rem',
              borderRadius: '4px',
              cursor: 'pointer',
              width: '100%'
            }}
          >
            Logout
          </button>
        </div>

        {/* TEST tag (only in TEST) */}
        {isTest && (
          <div style={{ padding: '0.75rem 1rem', borderTop: '1px solid #ddd' }}>
            <span
              style={{
                padding: '4px 10px',
                borderRadius: 999,
                fontWeight: 700,
                background: '#fff3cd',
                color: '#8a6d3b',
                border: '1px solid #f0ad4e'
              }}
            >
              TEST
            </span>
          </div>
        )}

        {/* Commit & Version */}
        <div style={{ padding: '0.5rem 1rem', fontSize: '0.8rem', color: '#333', borderTop: '1px solid #ddd' }}>
          {GIT_SHA ? <div style={{ marginBottom: 4 }}>Commit: {GIT_SHA}</div> : null}
          <div style={{ color: '#555' }}>{version ? `Proload Version: ${version}` : 'Loading version...'}</div>
        </div>
      </nav>

      {/* Main content area (orange border in TEST) */}
      <main
        style={{
          marginLeft: 220,
          padding: '1.25rem',
          minHeight: '100vh',
          boxSizing: 'border-box'
        }}
      >
        <div
          className="data-shell"
          style={
            isTest
              ? { border: '3px solid orange', borderRadius: 8, padding: '1rem' }
              : {}
          }
        >
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
